import { useEffect, useState } from "react";

interface IUseNowProps {
  isActive: boolean;
  intervalMs: number;
}

// NOTE: NSAI-7067 — a clock that re-renders its caller while `isActive`, so a
// "2 min left" estimate keeps counting down between progress events (a slow
// transfer can go seconds without one). Stops ticking when inactive, so an
// idle popup costs nothing.
export const useNow = ({ isActive, intervalMs }: IUseNowProps): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    setNow(Date.now());
    const intervalId = window.setInterval(() => {
      setNow(Date.now());
    }, intervalMs);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isActive, intervalMs]);

  return now;
};
